const checkPasswordStrength = (password) => {
  if (password.length < 8) {
    return signupVars.messages.passwordLength;
  }

  if (!/[A-Z]/.test(password)) {
    return signupVars.messages.passwordUppercase;
  }

  if (!/[a-z]/.test(password)) {
    return signupVars.messages.passwordLowercase;
  }

  if (!/[0-9]/.test(password)) {
    return signupVars.messages.passwordNumber;
  }

  return null;
};

const validateSignupForm = (username, email, password, confirmPassword) => {
  const errors = [];

  if (username.length < 3) {
    errors.push(signupVars.messages.usernameTooShort);
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.push(signupVars.messages.invalidEmail);
  }

  const passwordError = checkPasswordStrength(password);
  if (passwordError) {
    errors.push(passwordError);
  }

  if (password !== confirmPassword) {
    errors.push(signupVars.messages.passwordMismatch);
  }

  return errors;
};

const handleSignupSubmit = async (form) => {
  const formMessage = form.querySelector(".form-message");

  const username = form.querySelector('[name="username"]').value;
  const email = form.querySelector('[name="email"]').value;
  const password = form.querySelector('[name="password"]').value;
  const confirmPassword = form.querySelector('[name="confirm_password"]').value;

  const validationErrors = validateSignupForm(
    username,
    email,
    password,
    confirmPassword
  );

  if (validationErrors.length > 0) {
    formMessage.textContent = validationErrors[0];
    formMessage.classList.remove("success");
    formMessage.classList.add("error");
    return;
  }

  try {
    const formData = new FormData(form);
    formData.append("action", "handle_signup");
    formData.append("nonce", signupVars.nonce);

    const response = await fetch(signupVars.ajaxUrl, {
      method: "POST",
      body: formData,
      credentials: "same-origin",
    });

    const data = await response.json();

    if (data.success) {
      formMessage.textContent = data.data.message;
      formMessage.classList.remove("error");
      formMessage.classList.add("success");
      form.reset();

      // Redirect after showing success message
      setTimeout(() => {
        window.location.href = data.data.redirect_url;
      }, 1000);
    } else {
      formMessage.textContent = data.data.message;
      formMessage.classList.remove("success");
      formMessage.classList.add("error");
    }
  } catch (error) {
    formMessage.textContent = signupVars.messages.error;
    formMessage.classList.remove("success");
    formMessage.classList.add("error");
  }
};

export const initSignupForm = () => {
  const signupForm = document.getElementById("signup-form");
  if (signupForm) {
    signupForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      await handleSignupSubmit(signupForm);
    });
  }
};
